// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Dp-z","imageAndVideoCount":"Ep-z","imageAndVideoContainer":"Fp-z","viewAllReviews":"Gp-z"};